import { Pipe, PipeTransform } from "@angular/core";

export interface DurationTrajet {
  hours: number;
  minutes: number;
}

@Pipe({
  name: "durationTrajet",
  standalone: false,
})
export class DurationTrajetPipe implements PipeTransform {
  transform(value: DurationTrajet | null | undefined): string {
    if (!value || (value.hours == null && value.minutes == null)) return "0 min";
    const hours = value.hours ?? 0;
    const minutes = Math.round(value.minutes ?? 0);
    if (hours > 0) return `${hours} h ${minutes} min`;
    return `${minutes} min`;
  }
}
